export class OrderDiagnosis{
    //TODO: Erick perguntar a Ramon onde colocar essas classes
    id: number;
    order: any;
    cid: any;
    main: boolean = false;
    type: string;
}